import { authFetch } from './auth-fetch';

/**
 * Track an onboarding activity
 */
export async function trackActivity(stepId: string, siteId?: string) {
  try {
    // Get site ID from localStorage if not provided
    if (!siteId) {
      const selectedSite = localStorage.getItem('selectedSite');
      if (selectedSite) {
        const site = JSON.parse(selectedSite);
        siteId = site._id || site.id;
      }
    }

    if (!siteId) {
      console.warn('[Tracking] No site ID available for tracking');
      return;
    }

    const response = await authFetch('/onboarding/track', {
      method: 'POST',
      body: JSON.stringify({
        siteId,
        activity: {
          type: 'page_visit',
          stepId,
          timestamp: new Date().toISOString()
        }
      })
    });

    if (response.ok) {
      console.log(`[Tracking] Successfully tracked ${stepId}`);
    } else {
      console.error('[Tracking] Failed to track activity:', await response.text());
    }
  } catch (error) {
    console.error('[Tracking] Error tracking activity:', error);
  }
}

/**
 * Track simulation start
 */
export async function trackSimulation(siteId: string) {
  try {
    const response = await authFetch('/onboarding/track', {
      method: 'POST',
      body: JSON.stringify({
        siteId,
        activity: {
          type: 'simulation_started',
          timestamp: new Date().toISOString()
        }
      })
    });

    if (response.ok) {
      console.log('[Tracking] Successfully tracked simulation');
    }
  } catch (error) {
    console.error('[Tracking] Error tracking simulation:', error);
  }
}

/**
 * Track agent chat
 */
export async function trackAgentChat(siteId: string) {
  try {
    const response = await authFetch('/onboarding/track', {
      method: 'POST',
      body: JSON.stringify({
        siteId,
        activity: {
          type: 'agent_chat_started',
          timestamp: new Date().toISOString()
        }
      })
    });

    if (response.ok) {
      console.log('[Tracking] Successfully tracked agent chat');
    }
  } catch (error) {
    console.error('[Tracking] Error tracking agent chat:', error);
  }
}